export default {
  esg_dashboard: {
    title: 'Bảng điều khiển',
  },
  improvement_plans: {
    title: 'Kế hoạch cải thiện',
  },
  question_group_section: {
    card_title: 'Khảo sát chưa trả lời',
    list_header_buyer_company_name: 'Công ty bên mua',
    list_header_question: '@:score_summary_section.list_header_question',
    list_header_deadline: 'Hạn cuối',
    list_header_status: 'Trạng thái',
    number_of_answered_label: 'Số câu trả lời',
    // number_of_answered_unit: '',
    number_of_answered: 'Đang tiến hành： {answered}/{total}',
    status_re_answer_request: 'Đang tiến hành yêu cầu rút lại',
    answer: 'Câu trả lời',
    withdrawn: 'Đã rút lại',
    // no_survey_response_requests_text_1:  '',
    // contact: '',
    // no_survey_response_requests_text_2: '',
  },
  score_summary_section: {
    card_title: '@:common.scorecard.title',
    list_header_buyer_company_name: 'Công ty bên mua',
    list_header_question: 'Phiếu câu hỏi',
    list_header_create_at: 'Ngày phát hành',
    list_header_deadline: 'Ngày có hiệu lực',
    list_header_status: 'Trạng thái',
    limit_one_year: 'Một năm kể từ ngày phát hành',
    esg_score: 'Điểm ESG',
    esg_rating: 'Xếp hạng ESG',
    detail: 'Chi tiết',
  },
  faq_section: {
    card_title: 'Câu hỏi thường gặp',
    faq_why_request: {
      question:
        'Tại sao công ty tôi nhận được yêu cầu thực hiện đánh giá ASUENE ESG từ đối tác kinh doanh của mình?',
      answer:
        'Trong những năm gần đây, thu mua bền vững đã và đang là một xu hướng nổi bật và các công ty cần phải vận hành kinh doanh hướng đến các quy tắc xã hội liên quan đến ESG trong toàn bộ chuỗi cung ứng của mình. Với những nỗ lực như vậy, các doanh nghiệp lớn không chỉ cần thực hiện các sáng kiến ESG mà còn cần phải khuyến khích các đối tác kinh doanh của mình thực hiện ESG.',
    },
    faq_what_benefit: {
      question: 'Lợi ích của việc thực hiện đánh giá ASUENE ESG là gì?',
      answer:
        'Có ba lợi ích khi thực hiện đánh giá ASUENE ESG.\n1) Hiểu được điểm mạnh và những điểm cần cải thiện của công ty mình về ESG\n2) So sánh đánh giá của công ty mình với các công ty khác trong ngành\n3) Đẩy mạnh các sáng kiến ESG của công ty bằng cách công bố kết quả đánh giá',
    },
    list: 'Xem danh sách',
  },
  contact_section: {
    card_title: 'Liên hệ với chúng tôi',
    description:
      'Nếu có bất kỳ thắc mắc nào về phiếu câu hỏi hoặc cách trả lời, vui lòng liên hệ với chúng tôi bất cứ lúc nào. Nếu muốn được hỗ trợ cụ thể hơn để cải thiện các sáng kiến ESG, chúng tôi có thể tổ chức buổi hỗ trợ khác với các chuyên gia tư vấn.',
    inquiry: 'Liên hệ với chúng tôi',
  },
}
